export const setLoading = (state, action) => {
  const { loading } = state.config;

  if (loading) {
    const modified = loading.map((l) =>
      l.element === action.payload.element ? action.payload : l
    );
    const exists = modified.find((el) => el.element === action.payload.element);
    const result = exists ? modified : [...loading, action.payload];

    state.config.loading = result;
  } else {
    state.config.loading = [action.payload];
  }
};

export const expandCollapse = (state, action) => {
  switch (action.payload.type) {
    case "DOCS":
      state.config.docsCollapsed = action.payload.collapsed;
      break;
    case "CONTENT":
      state.config.contentCollapsed = action.payload.collapsed;
      break;
    case "RESET":
      state.config.docsCollapsed = false;
      state.config.contentCollapsed = false;
      break;
    default:
      break;
  }
};

export const showAllThemesAndItems = (state, action) => {
  const showAll = action.payload;
  const checkedThemes = Array.from(
    new Set(
      state.themes
        .filter((theme) => theme.checked)
        .map((theme) => theme.GroupName)
    )
  );

  if (showAll !== state.config.showAll) {
    state.config.saveSnapshotDisabled = false;
  }

  state.config.showAll = showAll;

  if (!checkedThemes.length && !showAll) {
    return state;
  }

  if (showAll) {
    state.themes = state.themes.map((t) => ({ ...t, selected: false }));
  } else {
    state.themes = state.themes.map((t) => ({
      ...t,
      // Either is checked or if is a group and contains checked nps
      selected:
        t.checked || (!t.NounPhrase && checkedThemes.includes(t.GroupName)),
    }));
  }

  return state;
};
